import React from "react";
import { Link } from "react-router-dom";
import CalltoActionSeven from "../../elements/calltoaction/CalltoActionSeven";
import ScrollTop from "./ScrollTop";
import {
  FiPhone,
  FiMail,
  FiMapPin,
  FiFacebook,
  FiLinkedin
} from "react-icons/fi";

const FooterTwo = () => {
  return (
    <>
      <footer className="rn-footer footer-style-default variation-two">
        <CalltoActionSeven />

        <div className="footer-top py-5">
          <div className="container">
            <div className="row g-5">

              {/* ✅ Company Info */}
              <div className="col-lg-4 col-md-6">
                <div className="rn-footer-widget">
                  <h6 className="title text-uppercase mb-3">Our Locations</h6>
                  <div className="inner">
                    <p className="small d-flex align-items-start mb-1">
                      <FiMapPin className="me-2 mt-1" />
                      <a
                        href="https://maps.google.com/?q=11.0572500,76.9787222"
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: 'inherit', textDecoration: 'none' }}
                        className="address-link"
                      >
                        Unit 1:<br />
                        SF.No: 99/2 A , Site no : 5 , Near Karupparayar Kovil,
                        School road, Chinnavedampatti , Coimbatore - 641049
                      </a>
                    </p>
                    <p className="small d-flex align-items-start mb-1">
                      <FiMapPin className="me-2 mt-1" />
                      <a
                        href="https://maps.google.com/?q=11.0558889,76.9776389"
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: 'inherit', textDecoration: 'none' }}
                        className="address-link"
                      >
                        Unit 2:<br />
                        9A, School Road, Chinnavedampatti, Ganapathy,
                        Coimbatore – 641 049, Tamil Nadu, India
                      </a>
                    </p>
                    <p className="small d-flex align-items-start mb-1">
                      <FiMapPin className="me-2 mt-1" />
                      <a
                        href="https://maps.app.goo.gl/zb4Gtij6ZADBXwqC9"
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: 'inherit', textDecoration: 'none' }}
                        className="address-link"
                      >
                        Unit 3:<br />
                        KR POWER SUPPORTS PVT LTD - 913/6 KESARIYA COMPLEX, BELOW AVINASHI ROAD FLYOVER, COIMBATORE - 641018
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              {/* ✅ Quick Links */}
              <div className="col-lg-2 col-md-6">
                <div className="rn-footer-widget">
                  <h6 className="title text-uppercase mb-3">Quick Links</h6>
                  <ul className="footer-link link-hover list-unstyled small">
                    {[
                      { text: "Home", url: "/" },
                      { text: "About", url: "/about-us" },
                      { text: "Products", url: "/products" },
                      // { text: "Clients", url: "/clients" },
                      // { text: "Blog", url: "/blog" },
                      { text: "Contact", url: "/contact" }
                    ].map((item, i) => (
                      <li key={i}>
                        <Link to={item.url}>{item.text}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* ✅ Products */}
              <div className="col-lg-3 col-md-6">
                <div className="rn-footer-widget">
                  <h6 className="title text-uppercase mb-3">Industries We Serve</h6>
                  <ul className="footer-link link-hover list-unstyled small">
                    {[
                      { text: "Solar Power Plants" },
                      { text: "Electrical & Power Distribution" },
                      { text: "Oil & Gas Industries" },
                      { text: "Paper Mills & Foundries" }
                    ].map((item, i) => (
                      <li key={i}>
                        {item.url ? <Link to={item.url}>{item.text}</Link> : <span>{item.text}</span>}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* ✅ Contact & Social */}
              <div className="col-lg-3 col-md-6">
                <div className="rn-footer-widget">
                  <h6 className="title text-uppercase mb-3">Get in Touch</h6>
                  <div className="inner">
                    <p className="small d-flex align-items-center mb-2">
                      <FiPhone className="me-2" /> +0422 253 5622
                    </p>

                    <p className="small d-flex align-items-center mb-3">
                      <FiMail className="me-2" /> info@krpower.in
                    </p>

                    <ul className="social-icon social-default justify-content-start d-flex gap-3">
                      <li>
                        <a
                          href="https://www.facebook.com/krcabletray/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FiFacebook />
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.linkedin.com/in/k-r-power-supports-private-limited-2072a6162/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FiLinkedin />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>

            <hr className="my-4" />

            {/* ✅ Footer Bottom with Powered by Jaz Infotech */}
            <div className="text-center small">
              &copy; {new Date().getFullYear()} K.R. Power Supports Pvt Ltd. All
              Rights Reserved.
              {/* <span className="mx-2">|</span> */}
              {/* <Link to="/privacy-policy">Privacy Policy</Link> */}
              {/* <span className="mx-2">|</span> */}
              {/* Powered by{" "} */}
              {/* <a
                href="https://gripples.in/"
                target="_blank"
                rel="noreferrer"
                style={{ fontWeight: "600", color: "#0d6efd" }}
              >
                Gripples
              </a> */}
            </div>
          </div>
        </div >
      </footer >

      <ScrollTop />
    </>
  );
};

export default FooterTwo;
